module.exports = __webpack_public_path__ + "static/media/logo_skadden.17dd23c8.png";